import { gql } from 'graphql-tag';

export default gql`
  query CourierLocation(
    $courier: String
    $trackingNumber: String!
    $limit: Int
  ) {
    courierLocation(
      courier: $courier
      trackingNumber: $trackingNumber
      limit: $limit
    ) {
      courierName
      trackingNumber
      courierLocationEvents {
        eventTimestamp
        latitude
        longitude
      }
    }
  }
`;
